import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import classes from "./FocusTags.module.css";
import Fonts from "../assets/Fonts";
import Color from "../assets/Colors";
import Colors from "../assets/Colors";
import { ReactSVG } from "react-svg";
import { TrashIconGray } from "../../constant/imagePath";

const FocusTags = () => {
  return (
    <div className={classes.main}>
      <div>
        <p className={classes.firstP} style={{ ...Fonts.otherSemiBold, color: Colors.neutralShadesOfDimGray }}>Saved filters</p>
        <div className={classes.d_bet}>
          <p style={{ ...Fonts.p2, color: Color.neutralShadesOfNero }}>
            Tennis Coaches
          </p>
          <div>{<ReactSVG src={TrashIconGray} />}</div>
        </div>
        <div className={classes.d_bet}>
          <p style={{ ...Fonts.p2, color: Color.neutralShadesOfNero }}>
            Coach for Adam
          </p>
          <div>{<ReactSVG src={TrashIconGray} />}</div>
        </div>
        <div className={classes.d_bet}>
          <p style={{ ...Fonts.p2, color: Color.neutralShadesOfNero }}>
            {" "}
            Coach for me
          </p>
          <div>{<ReactSVG src={TrashIconGray} />}</div>
        </div>
      </div>
    </div>
  );
};

export default FocusTags;
